import implement from 'implement-js'
import { ProvidersInterface } from '../../interfaces/providers'

const Providers = {
  AuthenticationProvider: ({ children }) => children,
}

export default implement(ProvidersInterface)(Providers)
